import posthogPlugin from '@/plugins/posthog';

export function initPostHog(vue) {
  const isEnabled = process.env.VUE_APP_ENV === 'production';

  if (isEnabled) {
    vue.use(posthogPlugin);
  }
}
